import produce from 'immer';
import {
  NICKNAME_LOG_LIST_REQUEST,
} from '../../constants/log/nicknameTransactionLogConstants';

const initialState = {

};

const nicknameTransactionLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case NICKNAME_LOG_LIST_REQUEST:
      break;
    default:
      break;
  }
});

export default nicknameTransactionLogReducer;
